import React, { useEffect, useState } from "react"
import { Modal, Button } from "react-bootstrap"
import PropTypes from "prop-types"
import { useIntl } from "react-intl"

import { API_STATUS, Required } from "../../../../shared_components/widgets/utils"
import { withSampleConfig } from "../../../../config/SampleConfigProvider"
import SampleSchedule from "../../SampleScheduleTab/SampleSchedule"
import { getFormattedMessage } from "../../../shared_components_registration"
import { useSensePageWidth } from "../../SampleScheduleTab/FormSamplePoint"

const ModalCreateSampleRoundTemplate = ({
  show,
  onHide,
  initStatus,
  // SampleConfigProvider
  sample_template_create_error,
  sample_template_create_status,
  updateMetrics,
  getSampleRoundTemplates,
  getSelectedSamplePoints,
  createSampleRoundTemplate,
  user_permissions = [],
  // --- SampleConfigProvider
}) => {
  const pageWidth = useSensePageWidth()

  const intl = useIntl()
  const [statusCreate, setStatusCreate] = useState(null)
  const [errors, setErrors] = useState({})
  const [data, setData] = useState({ name: "" })

  useEffect(() => {
    setErrors(sample_template_create_error)
  }, [sample_template_create_error])

  useEffect(() => {
    if (sample_template_create_status === API_STATUS.ERROR) {
      alert(
        intl.formatMessage({
          id: "samplemaangement.error.creating.new.template",
        }),
      )
    } else if (sample_template_create_status === API_STATUS.SUCCESS) {
      getSampleRoundTemplates()
      onHide()
    }
    setStatusCreate(sample_template_create_status)
  }, [sample_template_create_status])

  const createSampleTemplate = (event) => {
    event.preventDefault()
    updateMetrics(initStatus)

    const list_sample_points = getSelectedSamplePoints().filter((sp) => (sp?.["samples_to_create"] || 0) > 0)
    if (list_sample_points.length) {
      let msg = `${intl.formatMessage({
        id: "samplemanagement.selected.sample.points.message",
      })}:`

      const _sp_names = (list_sample_points || []).map((sp) => sp["sample_conn_no"])
      msg += `\n${_sp_names.join(", ")}`

      msg += `\n${intl.formatMessage({
        id: "samplemanagement.do-you-want-to-create-template",
      })}`

      if (!confirm(msg)) {
        return false
      } else {
        const _sp_ids = (list_sample_points || []).map((sp) => sp["id"])

        createSampleRoundTemplate({
          ...data,
          sampling_points: _sp_ids,
        })
      }
    } else {
      alert(
        intl.formatMessage({
          id: "samplemanagement.select.at.least.one.sample.point",
        }),
      )
    }
  }

  const createTemplateString = getFormattedMessage("samplemanagement.create.template", "Create Template")

  return (
    <Modal show={show} onHide={onHide} backdrop={"static"} keyboard={true} className={"overflow-scroll"}>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className={"fa fa-list-alt"} />
          &nbsp;&nbsp;
          {createTemplateString}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form name={"form_createTemplate"} style={{ width: `${Math.max(pageWidth - 100, 850)}px` }}>
          <div style={{ marginBottom: "10px" }}>
            {getFormattedMessage(
              "samplemanagement.select.at.least.one.sample.point",
              "Please Select at Least One Sample Point",
            )}
            :
          </div>
          <SampleSchedule allowSelection={true} allowActions={false} largeScreenCutoff={1350} />
          <div className={`one-rem-margin-bottom ${errors.name ? "has-error" : ""}`}>
            <label>
              {getFormattedMessage("general.name", "Name")}
              <Required />:
            </label>
            <input
              type={"text"}
              className={"form-control"}
              name={"name"}
              value={data.name}
              placeholder={
                `${intl.formatMessage({
                  id: "samplemanagement.template.name",
                })} ` + `(${intl.formatMessage({ id: "general.must.be.unique" })})`
              }
              onChange={(event) => {
                event.preventDefault()
                let d = Object.assign({}, data)
                setData({
                  ...d,
                  [event.target.name]: event.target.value,
                })
              }}
              required
            />
            <span className={"form-text text-danger"}>{errors.name}</span>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <div style={{ marginLeft: "auto" }}>
          <Button variant={"outline-primary"} onClick={onHide} disabled={statusCreate === API_STATUS.LOADING}>
            {getFormattedMessage("general.closeButton", "Close")}
          </Button>
          &nbsp;&nbsp;
          <Button
            variant={"primary"}
            disabled={
              statusCreate === API_STATUS.LOADING || !user_permissions.includes("add_sampleroundtemplate")
            }
            onClick={createSampleTemplate}
          >
            <span className={"fa fa-play text_white"} />
            &nbsp;&nbsp;
            {createTemplateString}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default withSampleConfig(ModalCreateSampleRoundTemplate)

ModalCreateSampleRoundTemplate.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  initStatus: PropTypes.object.isRequired,
  sample_template_create_error: PropTypes.object,
  sample_template_create_status: PropTypes.string,
  updateMetrics: PropTypes.func.isRequired,
  getSampleRoundTemplates: PropTypes.func.isRequired,
  getSelectedSamplePoints: PropTypes.func.isRequired,
  createSampleRoundTemplate: PropTypes.func.isRequired,
  user_permissions: PropTypes.array,
}
